var map = {
	"./game_bg.mp4": "0e25",
	"./game_bg_old.mp4": "af00",
	"./game_dial_01.mp4": "12f1",
	"./game_dial_02.mp4": "171b",
	"./game_dial_03.mp4": "0fe8",
	"./game_dot_01.mp4": "c44f",
	"./game_dot_02.mp4": "262a",
	"./game_dot_03.mp4": "2727",
	"./game_grid_01.mp4": "be8e",
	"./game_grid_02.mp4": "64ed",
	"./game_grid_03.mp4": "2bed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e99b";